import React, { useState, useRef, useMemo } from 'react';
import { ICellRendererParams } from '@ag-grid-community/core';
import ProcessDiscoveryEmbedModal from './ProcessDiscoveryEmbedModal';
import {
  ContextParams,
  getPrimaryKeyValue,
} from 'common/visualizations/views/agGridReact/helpers/processDiscoveryHelper';
import { ForgePopover, ForgeIconButton, ForgeIcon } from '@tylertech/forge-react';
import ProcessDiscoveryContent from './ProcessDiscoveryContent';

interface Props {
  rowParams: ICellRendererParams;
  processDiscoveryContext: ContextParams;
  newTableActions: string[];
}

const ProcessDiscoveryViewButton: React.FC<Props> = ({
  rowParams,
  processDiscoveryContext,
  newTableActions,
}) => {
  const contextParams = processDiscoveryContext;
  const { primaryKeyColumn } = processDiscoveryContext;
  const primaryKeyValue = useMemo(
    () => getPrimaryKeyValue(rowParams, primaryKeyColumn),
    [primaryKeyColumn, rowParams],
  );
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedUrl, setSelectedUrl] = useState<string>('');
  const targetRef = useRef<HTMLDivElement>(null);

  // Don't render button if no primary key value
  if (!primaryKeyValue) {
    return null;
  }

  const onModalDismiss = () => {
    setShowModal(false);
    setSelectedUrl('');
  };

  const onLinkClick = (url: string) => {
    setShowModal(true);
    setSelectedUrl(url);
  };

  return (
    <div ref={targetRef} className="process-discovery-view">
      <ForgeIconButton
        id={`process-action-button-trigger-${primaryKeyValue}`}
        data-testid="process-action-button-id"
        className="tyler-icons"
        aria-label="process-discovery-view-button"
      >
        <ForgeIcon name="more_vert" />
      </ForgeIconButton>
      <ForgePopover targetElementRef={targetRef} anchor={`process-action-button-trigger-${primaryKeyValue}`}>
        <div className="process-discovery-popup">
          <ProcessDiscoveryContent
            primaryKeyValue={primaryKeyValue}
            contextParams={contextParams}
            onLinkClick={onLinkClick}
            newTableActions={newTableActions}
          />
        </div>
      </ForgePopover>
      {showModal ? (
        <ProcessDiscoveryEmbedModal url={selectedUrl} onDismiss={onModalDismiss} showModal={showModal} />
      ) : null}
    </div>
  );
};

export default ProcessDiscoveryViewButton;
